import Vue from 'vue';

export default {
    namespaced: true,

    // -----------------------------------------------------------------

    state: {
        all: []
    },

    // -----------------------------------------------------------------

    getters: {
        all: (state) => { return state.all }
    },

    // -----------------------------------------------------------------

    mutations: {
        SET_PAYMENTS(state, payments) {
            state.all = payments
        },
    },

    // -----------------------------------------------------------------

    actions: {
        index: (context, { user_id, data }) => {
            return Vue.api.get(`users/${user_id}/payments`, { params: data })
                .then(response => {
                    context.commit('SET_PAYMENTS', response.data.data)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        create: (context, { id, paymentType, code, weeks, pattern_code }) => {
            let data = {
                payment_type: paymentType
            }
            if (weeks) data.weeks = weeks
            if (code) data.code = code
            if (pattern_code) data.pattern_code = pattern_code

            return Vue.api.post(`users/${id}/payments`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        invoices: (context, id) => {
            return Vue.api.get(`payments/${id}/invoices`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        readTransaction: (context, {user_id, id}) => {
            return Vue.api.get(`users/${user_id}/transactions/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        }
    }
}